export enum FindingStatus {
  Draft,
  Captured,
  Reviewed,
  PendingRoundTable,
  Finalised,
  FinalisedPostRoundTable,
  Escalated,
}

export const displayReadableFindingStatus = (value: FindingStatus) => {
  switch (value) {
    case FindingStatus.Draft:
      return 'Draft';
    case FindingStatus.Captured:
      return 'Captured';
    case FindingStatus.Reviewed:
      return 'Reviewed';
    case FindingStatus.PendingRoundTable:
      return 'Pending Round Table';
    case FindingStatus.Finalised:
      return 'Finalised';
    case FindingStatus.FinalisedPostRoundTable:
      return 'Finalised';
    case FindingStatus.Escalated:
      return 'Escalated';
  }
};
